/**
 * Group API Utility Functions
 * Common utility functions for group API operations
 */

import { getAuthConfigFromStore } from '../../auth/authUtils';

/**
 * Check if group API is ready (authentication configured)
 * @returns True if authentication is configured
 */
export function isGroupApiReady(): boolean {
  return getAuthConfigFromStore() !== null;
}

/**
 * Validate email format
 * @param email - Email address to validate
 * @returns True if email format is valid
 */
export function validateEmailFormat(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}

/**
 * Validate group name
 * @param groupName - Group name to validate
 * @returns Error message if invalid, null if valid
 */
export function validateGroupName(groupName: string): string | null {
  if (!groupName || groupName.trim().length === 0) {
    return 'Group name cannot be empty';
  }
  
  if (groupName.trim().length < 2) {
    return 'Group name must be at least 2 characters';
  }
  
  if (groupName.trim().length > 50) {
    return 'Group name must be less than 50 characters';
  }
  
  return null;
}

/**
 * Validate PSN format
 * @param psn - PSN to validate
 * @returns Error message if invalid, null if valid
 */
export function validatePSN(psn: string): string | null {
  if (!psn || psn.trim().length === 0) {
    return 'PSN cannot be empty';
  }
  
  // Basic PSN validation (typically 11 characters alphanumeric)
  if (psn.length !== 11) {
    return 'PSN must be 11 characters';
  }
  
  if (!/^[A-Z0-9]+$/.test(psn.toUpperCase())) {
    return 'PSN must contain only letters and numbers';
  }
  
  return null;
}

/**
 * Validate group ID format
 * @param groupId - Group ID to validate
 * @returns Error message if invalid, null if valid
 */
export function validateGroupId(groupId: string): string | null {
  if (!groupId || groupId.trim().length === 0) {
    return 'Group ID cannot be empty';
  }
  
  return null;
}